
import { formatQuantityWithUnit } from '@/utils/helpers'
import { getNestedValue } from '@/utils/tableUtils'
import { formatTimestamp } from '@/utils/timeUtils'
import { IManufacturingPlan } from '@/utils/types/model/manufacturingPlan'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

interface ITableColumn {
  prop: string
  label: string
  sortable?: boolean | string
  formatter?: (row: IManufacturingPlan) => string
}

@Options({
  name: 'MoList',
  emits: ['detail', 'sort-change'],
})
export default class MoList extends Vue {
  @Prop({ type: Array, default: () => [] }) moData!: IManufacturingPlan[]

  get tableColumns(): ITableColumn[] {
    return [
      { prop: 'orderNumber', label: this.$t('order_number'), sortable: 'custom' },
      { prop: 'workCenterCode', label: this.$t('work_center_code'), sortable: 'custom' },
      { prop: 'manufacturedItemCode', label: this.$t('item_code'), sortable: 'custom' },
      {
        prop: 'plannedQuantityStockUnit',
        label: this.$t('planned_quantity'),
        formatter: (row: IManufacturingPlan) => formatQuantityWithUnit(row.plannedQuantityStockUnit, row.stockUnit),
      },
      {
        prop: 'transactionDate',
        label: this.$t('transaction_date'),
        sortable: 'custom',
        formatter: (row: IManufacturingPlan) =>
          formatTimestamp(new Date(row.manufactureCompletionDate as string).getTime()),
      },
    ]
  }

  getNestedValue(obj: Record<string, unknown>, path: string): unknown {
    return getNestedValue(obj, path)
  }

  handleRowClick(row: IManufacturingPlan) {
    this.$emit('detail', row.orderNumber)
  }

  handleSortChange(data: { prop: string; order: string | null }) {
    this.$emit('sort-change', data)
  }
}
